import React from 'react';
import './product-details-facets.scss';
import { ProductFacetMap } from '@zonofi/zono-money-store';

interface ProductDetailsFacetsProps {
  facets: ProductFacetMap;
  onSelectFacet: (facetCode: any, facetValue: any) => void;
  showOutOfStock: boolean;
  outOfStockFacetValueMap: Record<string, Record<string, boolean>>;
}

export const ProductDetailsFacets: React.FC<ProductDetailsFacetsProps> = ({
  facets,
  onSelectFacet,
  showOutOfStock,
  outOfStockFacetValueMap,
}) => {
  return (
    <div className="product-details-facets">
      {Object.keys(facets)?.map((facet: string, i: number) => {
        return (
          <div className="product-details-facets-facet font-primary" key={i}>
            <div className="product-details-facets-facet-header ">
              <span className="product-details-facets-facet-name ">
                {`${facets?.[facet]?.facetName || `{NA}`}`}:{' '}
              </span>
              <span className="font-primary-semibold">
                {
                  facets?.[facet]?.facetValues?.find((i) => i?.isActive)
                    ?.facetValue
                }
              </span>
            </div>
            <div className="product-details-facets-facet-list">
              {facets?.[facet]?.facetValues?.map((fValue, index) => {
                const facetValueCode = fValue?.facetValueCode ?? '';
                const isFacetValueOutOfStock = Boolean(
                  facetValueCode &&
                    outOfStockFacetValueMap?.[facet]?.[facetValueCode]
                );
                return (
                  <div
                    className={`product-details-facets-facet-list-item ${
                      fValue?.isActive
                        ? `product-details-facets-facet-list-item-active`
                        : ``
                    }`}
                    style={{
                      ...(showOutOfStock && isFacetValueOutOfStock
                        ? { minWidth: 80 }
                        : {}),
                      height: 20,
                      overflow: 'visible',
                    }}
                    onClick={() =>
                      onSelectFacet(
                        facets?.[facet]?.facetCode,
                        fValue?.facetValue
                      )
                    }
                    key={index}
                  >
                    <span className="font-primary">{fValue?.facetValue}</span>
                    {showOutOfStock && isFacetValueOutOfStock && (
                      <div
                        className="catalog-list-out-of-stack-tag"
                        style={{ marginTop: 4 }}
                      >
                        <span className="font-primary catalog-details-out-of-stack-tag-text">
                          OUT OF STOCK
                        </span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
